'use client';

import {
  useEffect,
} from 'react';
import {
  useRouter,
} from 'next/navigation';
import {
  useAuth,
} from '@/contexts/AuthContext';
import FullScreenSpinner from '@/core/components/FullScreenSpinner';

export default function NotFoundRedirect() {
  const { isAuthenticated, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (!isLoading) {
      const targetPath = isAuthenticated ? '/dashboard' : '/login';
      timer = setTimeout(() => {
        router.replace(targetPath);
      }, 50);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      };
    };
  }, [isAuthenticated, isLoading, router]);

  return (
    <FullScreenSpinner />
  );
}
